import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-employee-modal',
  templateUrl: './employee-modal.component.html',
  styleUrls: ['./employee-modal.component.scss'],
})
export class EmployeeModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  emplyees = null;
  mode = null;
  data = null;
  Success = null;
  titles = null;
  specials = null;
  depts = null;
  cities = null;
  countries = null;
  cats = null;
  nats = null;
  filterddata: any = [];
  private _searchText: string;

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value);
  }

  filterdata(searchString: string) {
    return this.emplyees.filter(
      (log) => log.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }

  groupForm = new FormGroup({
    name: new FormControl('', Validators.required),
    employee_type_id: new FormControl('', Validators.required),
    consultant_type: new FormControl('', Validators.required),
    specialisation: new FormControl('', Validators.required),
    department_code: new FormControl('', Validators.required),
    registration_no: new FormControl('', Validators.required),
    address1: new FormControl('', Validators.required),
    address2: new FormControl('', Validators.required),
    city_id: new FormControl('', Validators.required),
    country_id: new FormControl('', Validators.required),
    mobile: new FormControl('', Validators.required),
    email_no: new FormControl('', Validators.required),
    Designation: new FormControl('', Validators.required),
    Nationality: new FormControl('', Validators.required),
    write_off_authorised: new FormControl('', Validators.required),
    concession_authorised: new FormControl('', Validators.required),
    cancellation_authorised: new FormControl('', Validators.required),
    Admission_Authorised: new FormControl('', Validators.required),
    Indent_Authorisation: new FormControl('', Validators.required),
    title_name: new FormControl('', Validators.required),
    category_name: new FormControl('', Validators.required),
    PO_AUTH: new FormControl('', Validators.required),
    Status: new FormControl('', Validators.required),
    qualification: new FormControl('', Validators.required),
    id: new FormControl(0, Validators.required),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      id,
      employee_type_id,
      name,
      consultant_type,
      specialisation,
      department_code,
      registration_no,
      address1,
      address2,
      city_id,
      country_id,
      mobile,
      email_no,
      Designation,
      Nationality,
      write_off_authorised,
      concession_authorised,
      cancellation_authorised,
      Admission_Authorised,
      Indent_Authorisation,
      title_name,
      category_name,
      PO_AUTH,
      Status,
      qualification,
    } = this.groupForm.value;
    this.auth
      .postEmployee(
        id,
        employee_type_id,
        name,
        consultant_type,
        specialisation,
        department_code,
        registration_no,
        address1,
        address2,
        city_id,
        country_id,
        mobile,
        email_no,
        Designation,
        Nationality,
        write_off_authorised,
        concession_authorised,
        cancellation_authorised,
        Admission_Authorised,
        Indent_Authorisation,
        title_name,
        PO_AUTH,
        category_name,
        Status,
        qualification
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth.getTitle().subscribe(
      (resSuccess) => {
        this.titles = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getSpecials().subscribe(
      (resSuccess) => {
        this.specials = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getCity().subscribe(
      (resSuccess) => {
        this.cities = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getcountry().subscribe(
      (resSuccess) => {
        this.countries = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getCategories().subscribe(
      (resSuccess) => {
        this.cats = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getEmployees().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        this.filterddata = this.emplyees;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  addNew() {
    this.mode = 'add';
  }
  edit(emplyee) {
    this.mode = 'edit';
    // let { name, address1 } = this.groupForm.value;
    // name = emplyee.name;
    // address1 = emplyee.name;
    this.groupForm.patchValue({
      name: emplyee.name,
      id: emplyee.id,
      employee_type_id: emplyee.employee_type_id,
      consultant_type: emplyee.consultant_type,
      specialisation: emplyee.specialisation,
      department_code: emplyee.department_code,
      registration_no: emplyee.registration_no,
      address1: emplyee.address1,
      address2: emplyee.address2,
      city_id: emplyee.city_id,
      country_id: emplyee.country_id,
      mobile: emplyee.mobile,
      email_no: emplyee.email_no,
      Designation: emplyee.Designation,
      Nationality: emplyee.Nationality,
      write_off_authorised: emplyee.write_off_authorised,
      concession_authorised: emplyee.concession_authorised,
      cancellation_authorised: emplyee.cancellation_authorised,
      Admission_Authorised: emplyee.Admission_Authorised,
      Indent_Authorisation: emplyee.Indent_Authorisation,
      title_name: emplyee.title_name,
      category_name: emplyee.category_name,
      PO_AUTH: emplyee.PO_AUTH,
      Status: emplyee.Status,
      qualification: emplyee.qualification,
    });
    console.log(this.groupForm.value);
  }
}
